/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/cover': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M22.225 13.554a.502.502 0 00-.672.222c-.019.037-1.918 3.724-5.553 3.724s-5.534-3.687-5.553-3.724a.5.5 0 00-.895.448c.055.109.894 1.748 2.552 2.963l-.958.959a.5.5 0 00.708.708l1-1a.496.496 0 00.093-.14c.73.396 1.581.681 2.554.757V20a.5.5 0 001 0v-1.529a6.354 6.354 0 002.554-.757c.023.05.053.099.094.14l1 1a.502.502 0 00.705 0 .5.5 0 000-.707l-.957-.957c1.658-1.216 2.496-2.855 2.551-2.964a.503.503 0 00-.223-.672z"/><path pid="1" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/>'
  }
})
